module.exports = __webpack_public_path__ + "static/media/deepak.6e7b2b38.JPG";